<template>
    <div class="scroll-container" ref="scrollContainer">
        <slot ></slot>
        <slot name="icon"></slot>
        <slot name="footer"></slot>
    </div>
</template>
<script>
import BScroll from "better-scroll";
export default {
    props: {
        /**
         * @description 是否开启下啦加载
         */
        pullup: {
            type: [Boolean],
            default: true,
        },
        /**
         * @description 距离底部底部位置
         */
        offset: {
            type: [Number],
            default: 40,
        },
        /**
         * @description 同步数据
         */
        dataList: {
            type: [Array],
            default: function() {
                return [];
            },
        },
        /**
         * @description 是否完毕
         */
        finished: {
            type: [Boolean],
            default: false,
        },
    },
    name: "Scroll",
    data() {
        return {
            //bscroll实列
            scrollIntance: null,
            //定时器id
            timerId: null,
        };
    },
    mounted() {
        let _this = this;
        this.$nextTick(() => {
            _this.initBsroll();
            _this.scrollIntance.refresh();
        });
    },
    beforeDestroy() {
        window.clearTimeout(this.timerId);
        this.destroyBsroll();
    },
    methods: {
        /**
         * @description 初始化插件
         */
        initBsroll() {
            let _this = this;
            this.scrollIntance = new BScroll(this.$refs.scrollContainer, {
                scrollY: true,
                click: true,
                scrollbar: {
                    fade: true,
                    interactive: false,
                },
            });
            if (this.pullup) {
                this.scrollIntance.on("scrollEnd", () => {
                    if (
                        _this.scrollIntance.y <=
                        _this.scrollIntance.maxScrollY + _this.offset
                    ) {
                        if (!_this.finished) {
                            _this.$emit("load");
                        }
                    }
                });
            }
        },
        /**
         * @description 销毁插件
         */
        destroyBsroll() {
            if (this.scrollIntance) {
                this.scrollIntance.destroy();
            }
        },
        /**
         * @description 刷新
         */
        refresh() {
            if (this.scrollIntance) {
                this.dataListdataList.refresh();
            }
        },
    },
    watch: {
        /**
         * @description 监听数据重置刷新盒子
         */
        dataList: {
            handler: function(newVal, oldVal) {
                let _this = this;
                window.clearTimeout(this.timerId);
                window.setTimeout(() => {
                    if (_this.scrollIntance) {
                        _this.$nextTick(() => {
                            _this.scrollIntance.refresh();
                        });
                    }
                }, 20);
            },
            immediate: true,
            deep: true,
        },
    },
};
</script>
<style lang="less" scoped>
.scroll-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    > .scroll-content-box {
        width: 100%;
        height: 100%;
    }
}
</style>
